import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import Header from 'components/ui/Header';
import Icon from 'components/AppIcon';
import QuoteForm from './components/QuoteForm';

const SendQuotePage = () => {
  const { requestId } = useParams();
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  if (!user) {
    navigate('/login-form');
    return null;
  }

  return (
    <div className="min-h-screen" style={{ background: "linear-gradient(180deg, #f9fbfd 0%, #f3f7fb 100%)", minHeight: '100vh' }}>
      <Header />
      <div className="max-w-2xl mx-auto px-4 py-8">
        {/* Back Button */}
        <button
          onClick={() => navigate(`/request-detail/${requestId}`)}
          className="flex items-center gap-2 text-sm text-gray-600 hover:text-primary transition-colors mb-6"
        >
          <Icon name="ArrowLeft" size={16} />
          <span>← Torna alla richiesta</span>
        </button>

        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Invia Preventivo</h1>
          <p className="text-gray-500 text-sm">Compila i campi per inviare la tua offerta al cliente</p>
        </div>

        {/* Form */}
        <QuoteForm requestId={requestId} userId={user?.id} />
      </div>
    </div>
  );
};

export default SendQuotePage;
